<template>
  <h1 class="system_content_title">企业用户密码修改</h1>
  <div class="system_content_panels">
    <div
      class="systemPanel"
      style="position: relative; padding-bottom: 40px; width: 100%"
    >
      <el-form
        class="passEdit"
        ref="passFormRef"
        :model="passFrom"
        :rules="rules"
      >
        <el-form-item prop="loginName">
          <el-input
            class="form_item"
            size="large"
            v-model="passFrom.loginName"
            prefix-icon="Avatar"
            placeholder="请输入登录账号"
          ></el-input>
        </el-form-item>
        <el-form-item prop="oldPassword">
          <el-input
            class="form_item"
            size="large"
            type="password"
            v-model="passFrom.oldPassword"
            prefix-icon="Avatar"
            placeholder="请输入旧密码"
            show-password
          ></el-input>
        </el-form-item>
        <el-form-item prop="newPassword">
          <el-input
            class="form_item"
            size="large"
            type="password"
            v-model="passFrom.newPassword"
            prefix-icon="Stamp"
            placeholder="请输入新密码"
            show-password
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            class="pass-btn"
            size="large"
            type="primary"
            @click="validatePass(passFormRef)"
            >确认修改</el-button
          >
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script setup>
import { getCurrentInstance, reactive, ref } from "vue";
import { ElMessage } from "element-plus";
import api from "../../http/apis";
const { proxy } = getCurrentInstance();

const passFrom = reactive({ loginName: "", oldPassword: "", newPassword: "" });
const passFormRef = ref(null);

const rules = {
  loginName: [{ required: true, message: "请输入登录账号", trigger: "blur" }],
  oldPassword: [{ required: true, message: "请输入旧密码", trigger: "blur" }],
  newPassword: [{ required: true, message: "请输入新密码", trigger: "blur" }],
};

async function changePassword(form) {
  const { data } = await api.userApi.changePwd(form);
  if (data.isSuccessful) {
    ElMessage({
      message: data.resultMsg,
      type: "success",
    });
  } else {
    ElMessage({
      message: data.resultMsg || "[修改密码]未知错误",
      type: "error",
      grouping: true,
    });
  }
}

const validatePass = async (passFormRef) => {
  if (!passFormRef) {
    return;
  }
  await passFormRef.validate((valid, fields) => {
    if (valid) {
      changePassword(passFrom);
    }
  });
};
</script>



<style lang="scss" scoped>
.passEdit {
  width: 500px;
  margin: 100px auto;
  .pass-btn {
    margin: 0 auto;
  }
}
</style>
